export default "__VITE_ASSET__59082532__"